import { Candidato } from "./candidato.model";
import { Cargo } from "./cargo.model";

export class Voto {

    constructor(
        public id?: number,
        public cargo?: Cargo,
        public plano?:string,
        public ip?: string,
        public tipoVoto?: string,
        public justificativa?: string,
        public candidato?: Candidato,
        public createdAt?: string
    ) {

    }


}